import moment from 'moment-timezone';
import { api } from '@/f1/service';

import List from '../Policy.List.i18n';
import Detail from '../Policy.Detail.i18n';

export default {
  components: { List, Detail },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      if(!id) { this.base = this.list = !(this.detail = false); }
      else { this.detail = !(this.list = false); }
    }
  },
  created: function() {   console.log('policy.vue', 'created'); },
  destroyed: function() { console.log('policy.vue', 'destroyed'); },
  mounted: function() {
    console.log('policy.vue', 'mounted');
    this.select(this.$route.params);
  },
  watch: {
    '$route' (to, from) {
      console.log('policy.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
}
